/**
 * Entregar o JPEG da folha: baixar, ou compartilhar com o app da Canon.
 *
 * O app SELPHY só abre imagem. No celular, o menu de compartilhar do navegador
 * leva o arquivo direto a ele; no computador, baixa-se e abre-se pelo app ou
 * pelo sistema de impressão.
 */

export function nomeDaFolha(layout: string, agora = new Date()): string {
  const p = (n: number) => String(n).padStart(2, "0");
  const dia = `${agora.getFullYear()}-${p(agora.getMonth() + 1)}-${p(agora.getDate())}`;
  const hora = `${p(agora.getHours())}${p(agora.getMinutes())}`;
  return `folha-${layout}-${dia}-${hora}.jpg`;
}

export function baixarArquivo(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Adiado: revogar já pode cancelar o download em alguns navegadores.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/** O navegador sabe compartilhar um arquivo de imagem? (celulares, em geral) */
export function podeCompartilharArquivo(): boolean {
  if (typeof navigator === "undefined" || typeof navigator.canShare !== "function") return false;
  try {
    return navigator.canShare({ files: [new File([""], "x.jpg", { type: "image/jpeg" })] });
  } catch {
    return false;
  }
}

/** Compartilha o JPEG. Cancelar o menu do sistema não é erro. */
export async function compartilharArquivo(
  blob: Blob,
  nome: string,
  titulo = "Folha de impressão",
): Promise<void> {
  const arquivo = new File([blob], nome, { type: "image/jpeg" });
  try {
    await navigator.share({ files: [arquivo], title: titulo });
  } catch (e) {
    if (e instanceof DOMException && e.name === "AbortError") return;
    throw e;
  }
}
